/* eslint-disable camelcase */
import { BACKORDER, ORDER } from '@config/const';
import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getNews: builder.query({
      query: () => ({ url: 'customer/dashboard/news' }),
      transformResponse: (response) =>
        response.map(({ id, created, notification_type, description }) => ({
          id,
          created,
          description,
          type: notification_type,
        })),
    }),
    getOpenOrders: builder.query({
      query: () => ({ url: 'customer/orders/dashboard' }),
      transformResponse: (response) => {
        const { backorders, orders } = response;
        const data = [
          ...backorders.map((item) => ({ type: BACKORDER, ...item })),
          ...orders.map((item) => ({ type: ORDER, ...item })),
        ];
        return data.sort((a, b) =>
          a.reference_number > b.reference_number ? -1 : 1
        );
      },
    }),
    getAccountSnapshot: builder.query({
      query: () => ({ url: 'customer/reports/account-snapshot' }),
      transformResponse: (response) => {
        const others = {
          dids_amount: 0,
          country: {
            name: 'Others',
            flag_href: '',
          },
          minutes_last_7_days: {
            inbound: 0,
            outbound: 0,
          },
          others: [],
        };
        const othersList = response.slice(3);
        othersList.forEach((item) => {
          others.dids_amount += item.dids_amount;
          others.minutes_last_7_days.inbound +=
            item.minutes_last_7_days.inbound;
          others.minutes_last_7_days.outbound +=
            item.minutes_last_7_days.outbound;
          others.others.push(item);
        });
        const result = [...response.slice(0, 3)];
        if (others.dids_amount === 0) {
          return result;
        }
        return [...result, others];
      },
    }),
    getUserManualData: builder.query({
      query: () => ({ url: 'customer/dashboard/user-manual-data' }),
    }),
    totalUnbilledTraffic: builder.query({
      query: () => ({ url: 'customer/dashboard/total-unbilled-traffic' }),
    }),
  }),
});

const initialState = {
  accountSnapshot: {
    data: [],
    isLoading: false,
  },
  news: {
    data: [],
    isLoading: false,
  },
  order: {
    data: [],
    isLoading: false,
  },
  balance: {
    date: '',
    belowThreshold: null,
    isLoading: false,
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: (builder) => builder,
});

export default dashboardSlice.reducer;
